import { X, Trash, SquarePen, User, Form, Tickets } from "lucide-react"
import styles from "./ModalDataCar.module.css"
import { useEffect, useState } from "react";
import SectionRegister from "../SectionRegister";
import Interaction from "./Interaction";
import { getInteractions } from "../../api/tickets.api";
import { toast } from "react-toastify";

function ModalDataTicket({ setIsOpen, thisTicket, setIsOpenEdit, setIsOpenDelete, setIsOpenEditStatus }) {
    const [sectionSelected, setSectionSelected] = useState("Registro");
    const [interactionsArray, setInteractions] = useState([])

    useEffect(() => {
        getInteractions(thisTicket.id)
            .then((response) => setInteractions(response.data))
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }, [])

    const dataRegister = [
        {
            label: "ID",
            value: thisTicket.codigo,
        },
        {
            label: "STATUS",
            value: thisTicket.status
        },
        {
            label: "DATA ABERTURA",
            value: thisTicket.dataAbertura,
        },
        {
            label: "DATA PREVISÃO",
            value: thisTicket.dataPrevisao,
        },
        {
            label: "PLACA CARRO",
            value: thisTicket.car === null || thisTicket.car === undefined ? "----------" : thisTicket.car.placa,
        },
        {
            label: "CHECKLIST",
            value: thisTicket.checklistId == 0 ? "------" : thisTicket.checklistId
        },
        {
            label: "CUSTO",
            value: `R$ ${thisTicket.custo}`,
        },
        {
            label: "OFICINA",
            value: thisTicket.oficina === null || thisTicket.oficina === undefined ? "----------" : thisTicket.oficina
        },
        {
            label: "OCORRÊNCIAS",
            value: thisTicket.quantidadeOcorrencias === null || thisTicket.quantidadeOcorrencias === undefined ? "0" : thisTicket.quantidadeOcorrencias
        },
        {
            label: "ULTIMA OCORRÊNCIA",
            value: thisTicket.ultimaOcorrencia === null || thisTicket.ultimaOcorrencia === undefined ? "----------" : thisTicket.ultimaOcorrencia
        }
    ]


    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerHeader}>
                    <div className={styles.extra}>
                        <div className={styles.icon}>
                            <Tickets color="#fff" size={28} />
                        </div>
                        <div className={styles.infoHeader}>
                            <h3>{`Ticket ${thisTicket.codigo}`}</h3>
                            <div className={styles.infoCar}>
                                <p>{thisTicket.car === null ? "----------" : thisTicket.car.placa}</p>
                                {thisTicket.checklistId != 0 ? <p>{`CHECK ID: ${thisTicket.checklistId}`}</p> : ""}

                            </div>
                        </div>
                    </div>
                    <div className={styles.x}>
                        <X onClick={() => setIsOpen(false)} color="#fff" />
                    </div>
                </div>
                <div className={styles.options}>
                    <button
                        className={sectionSelected == "Registro" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Registro")}
                    >
                        Registro
                    </button>
                    <button
                        className={sectionSelected == "Interações" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Interações")}
                    >
                        Interações
                    </button>
                </div>
                <div className={styles.content}>
                    {sectionSelected == "Registro" && (
                        <SectionRegister
                            thisEntity={dataRegister}
                            descExtra={[
                                {
                                    label: "DESCRIÇÃO",
                                    value: thisTicket.descricao
                                }
                            ]}
                        />
                    )}
                    {sectionSelected == "Interações" && (
                        <section className={styles.interacoes}>
                            {interactionsArray.map((interaction) => (
                                <Interaction
                                    key={interaction.id}
                                    thisInteraction={interaction}
                                />
                            ))}
                        </section>
                    )}
                </div>
                <div className={thisTicket.status == "Finalizado" ? styles.buttonOperations : styles.buttonOperationsTrue}>
                    {thisTicket.status == "Finalizado" ? "" : <button
                        className={styles.edit}
                        onClick={() => {
                            setIsOpen(false)
                            setIsOpenEditStatus(true)
                        }}
                    >
                        <SquarePen size={14} color="#1d121b" />
                        Interagir
                    </button>}
                    {thisTicket.status == "Finalizado" ?
                        <button
                            className={styles.edit}
                            onClick={() => {
                                setIsOpen(false)
                                setIsOpenEdit(true)
                            }}
                        >
                            <SquarePen size={14} color="#1d121b" />
                            Reabrir
                        </button>
                        : <button
                            className={styles.edit}
                            onClick={() => {
                                setIsOpen(false)
                                setIsOpenEdit(true)
                            }}
                        >
                            <SquarePen size={14} color="#1d121b" />
                            Editar
                        </button>}


                    <button
                        className={styles.delete}
                        onClick={() => {
                            setIsOpen(false);
                            setIsOpenDelete(true)
                        }}
                    >
                        <Trash size={14} color="#fff" />
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalDataTicket;